import { render } from "./list-quote.vue?vue&type=template&id=0dec3485&scoped=true"
import script from "./list-quote.vue?vue&type=script&lang=js"
export * from "./list-quote.vue?vue&type=script&lang=js"

import "./list-quote.vue?vue&type=style&index=0&id=0dec3485&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dec3485"]])

export default __exports__